import { formatPagination } from '../../utils/pagination';
import { EMPTY_ISSUE_COLUMN } from './issueTracker.constants';

/**
 * State setters for the Jira tab. Pure `setState` sugar — no fetching, no
 * branching beyond shaping what the controller hands it.
 *
 * Every key is prefixed `issue*` so the two tabs on this screen cannot collide:
 * the tickets tab owns `tickets` / `pagination` / `statusTab`, this one owns
 * `issueRows` / `issueStatusFilter` / `issueView`.
 */
class IssuesDelegate {
    setIssuesLoading(loading) {
        this.setState({ issuesLoading: loading });
    }

    setIssuesPerPage(value, callback) {
        this.setState({ issuesPageSize: value }, callback);
    }

    /**
     * Install one page of the TABLE.
     *
     * `sync` is stored even when the page is empty — it is what tells the screen
     * whether "nothing here" means "nothing matches" or "the mirror never ran".
     */
    setIssuesPage(items, pageinfo, sync) {
        this.setState({
            issueRows: items || [],
            issuePageInfo: pageinfo || {},
            issuePagination: pageinfo ? formatPagination(pageinfo) : null,
            issueSync: sync || null,
            issuesError: false,
            issuesLoaded: true,
        });
    }

    /**
     * A failed request. The rows are cleared deliberately: showing a previous
     * page under an error banner would assert the work is current when we do not
     * know that.
     */
    setIssuesError() {
        this.setState({
            issuesError: true,
            issueRows: [],
            issuePagination: null,
            issueSync: null,
            // "Asked and failed" still counts as asked; the error state is what
            // the screen shows, and switching tabs must not silently retry.
            issuesLoaded: true,
        });
    }

    /**
     * Patch ONE board column.
     *
     * Each column owns its own page, total and in-flight flag, because each is a
     * separate `?status=` query that the user scrolls independently — Queued
     * being three pages deep says nothing about Done.
     *
     * @param {string} statusKey
     * @param {object} patch
     */
    setIssueColumn(statusKey, patch) {
        this.setState((prev) => ({
            issueBoard: {
                ...prev.issueBoard,
                [statusKey]: { ...EMPTY_ISSUE_COLUMN, ...(prev.issueBoard?.[statusKey] || {}), ...patch },
            },
        }));
    }

    /** Drop every column back to empty — a reload, not an append. */
    resetIssueBoard() {
        this.setState({ issueBoard: {} });
    }

    setIssueStatusFilter(value, callback) {
        this.setState({ issueStatusFilter: value }, callback);
    }

    setIssueView(value, callback) {
        this.setState({ issueView: value }, callback);
    }

    setSupportTab(value, callback) {
        this.setState({ supportTab: value }, callback);
    }
}

export default IssuesDelegate;
